// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JNjL","rootMobile":"styles_rootMobile__2KJo7"};